<template>
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="4" fill="#FF5C00"/>
<path d="M13.8925 22C13.6657 22 13.4388 21.9018 13.2597 21.6915C12.9134 21.2848 12.9134 20.6117 13.2597 20.2051L16.8418 15.9982L13.2597 11.7914C12.9134 11.3848 12.9134 10.7117 13.2597 10.305C13.606 9.89833 14.1791 9.89833 14.5254 10.305L18.7403 15.255C19.0866 15.6617 19.0866 16.3348 18.7403 16.7415L14.5254 21.6915C14.3463 21.9018 14.1194 22 13.8925 22Z" fill="#FFEFE6"/>
</svg>
</template>
<script lang="ts" setup>

</script>
